"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FrameRange = _interopRequireDefault(require("../interval/FrameRange"));

var _isAudible = _interopRequireDefault(require("../../utils/content/isAudible"));

var _isVisible = _interopRequireDefault(require("../../utils/content/isVisible"));

var _getMediaUrlByMedia = _interopRequireDefault(require("../../utils/media/getMediaUrlByMedia"));

var _appendQueryParams = _interopRequireDefault(require("../../utils/url/appendQueryParams"));

var _ascendingComparator = _interopRequireDefault(require("../../utils/array/ascendingComparator"));

var _combineParentAndChildTransforms = _interopRequireDefault(require("../../utils/transform/combineParentAndChildTransforms"));

var _getElementTransformAtFrame = _interopRequireDefault(require("../../utils/transform/getElementTransformAtFrame"));

var _isEmpty = _interopRequireDefault(require("../../utils/object/isEmpty"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _creative = require("../../constants/creative");

var _Rectangle = _interopRequireDefault(require("../geometry/Rectangle"));

var _group = require("../../constants/group");

var CreativeLayer = /*#__PURE__*/function () {
  /**
   * Active range represents the start and end frame of Creative Layer taking parents into account)
   */

  /**
   * Active range represents the start and end frame of Creative Layer taking parents into account)
   */

  /**
   * layer's audibility
   */

  /**
   * Model representation of element JSON
   */

  /**
   * Element Id of layer
   */

  /**
   * model representation of content JSON
   */

  /**
   * content ID of layer
   */

  /**
   * content store id. An id for populating the content store. (Used internally)
   */

  /**
   * content type of layer
   */

  /**
   * playback frames per second for the creative
   */

  /**
   * total number of frames in a creative
   */

  /**
   * Frame range represents the start and end frame of Creative Layer without taking parents into account)
   */

  /**
   * Creative Layer's ID (consists of element Id, content Id, media Id, and media URL)
   */

  /**
   * media's height
   */

  /**
   * model representation of media JSON
   */

  /**
   * media Id
   */

  /**
   * media url of creative layer
   */

  /**
   * parent layer
   */

  /**
   * layer's visibility
   */

  /**
   * media's width
   */
  function CreativeLayer(element, content, media) {
    (0, _classCallCheck2["default"])(this, CreativeLayer);
    (0, _defineProperty2["default"])(this, "_activeRange", null);
    (0, _defineProperty2["default"])(this, "_alphaCompositeRule", _creative.DEFAULT_ALPHA_BLEND_MODE);
    (0, _defineProperty2["default"])(this, "_audible", false);
    (0, _defineProperty2["default"])(this, "_element", null);
    (0, _defineProperty2["default"])(this, "_elementId", null);
    (0, _defineProperty2["default"])(this, "_content", null);
    (0, _defineProperty2["default"])(this, "_contentId", null);
    (0, _defineProperty2["default"])(this, "_contentStoreId", null);
    (0, _defineProperty2["default"])(this, "_contentType", null);
    (0, _defineProperty2["default"])(this, "_creativeFrameRate", _creative.PLAYBACK_FRAMES_PER_SECOND);
    (0, _defineProperty2["default"])(this, "_creativeNumberOfFrames", 0);
    (0, _defineProperty2["default"])(this, "_frameRange", null);
    (0, _defineProperty2["default"])(this, "_id", null);
    (0, _defineProperty2["default"])(this, "_height", 0);
    (0, _defineProperty2["default"])(this, "_media", null);
    (0, _defineProperty2["default"])(this, "_mediaId", null);
    (0, _defineProperty2["default"])(this, "_mediaURL", null);
    (0, _defineProperty2["default"])(this, "_parent", null);
    (0, _defineProperty2["default"])(this, "_visible", true);
    (0, _defineProperty2["default"])(this, "_width", 0);

    if ((0, _isNil["default"])(element) || (0, _isNil["default"])(content)) {
      throw new Error('To construct CreativeLayer, element and content must be provided');
    }

    this._element = element;
    this._content = content;
    this._media = media; // set up properties

    this._alphaCompositeRule = element.alphaCompositeRule;
    this._audible = (0, _isAudible["default"])(content);
    this._elementId = element.elementId;
    this._contentId = content.contentId;
    this._contentType = content.contentType;
    this._visible = (0, _isVisible["default"])(content);

    if ((0, _isNotNil["default"])(media)) {
      this._mediaId = media.mediaId;
      this._mediaURL = CreativeLayer.getMediaURL(this);
      this._height = media.height;
      this._width = media.width;
    } // generate Creative Layer's Id


    this._id = "e".concat(this.elementId, "-c").concat(this.contentId, "-m").concat(this.mediaId, "-mu").concat(this.mediaURL); // generate the Content Store ID

    this._contentStoreId = this.internalGenerateContentStoreId(); // set up ranges

    var _this$element = this.element,
        frameEnd = _this$element.frameEnd,
        frameStart = _this$element.frameStart;
    this._frameRange = new _FrameRange["default"](frameStart, frameEnd); // Always do this after setting frameRange and parent

    this._activeRange = CreativeLayer.getRootActiveRange(this);
  }

  (0, _createClass2["default"])(CreativeLayer, [{
    key: "getAbsoluteTransformsAtFrame",

    /**
     * Utility Helper to determine creative layer's absolute transform (parents + self)
     *
     * @param {number} frameNumber
     * @return {object}
     */
    value: function getAbsoluteTransformsAtFrame(frameNumber) {
      var elementJSON = this.element.toJSON();
      if ((0, _isEmpty["default"])(elementJSON)) return _creative.DEFAULT_KEYFRAME_TRANSFORM;
      var elementTransform = (0, _getElementTransformAtFrame["default"])(elementJSON, frameNumber, false); // if layer does not have a parent, we can return the transform

      if (!CreativeLayer.isCreativeLayer(this.parent)) return elementTransform;
      var parentTransform = this.parent.getAbsoluteTransformsAtFrame(frameNumber);
      return (0, _combineParentAndChildTransforms["default"])(parentTransform, elementTransform);
    }
    /**
     * Returns the first transform found starting at -1 and going to frameEnd, returns null if no transforms exist
     *
     * @param {number} frameNumber
     * @return {object}
     */

  }, {
    key: "getFirstTransform",
    value: function getFirstTransform() {
      if ((0, _isNil["default"])(this.transforms) || this.transforms.size < 1) {
        return null;
      }

      var firstKey = Array.from(this.transforms.keys()).sort(_ascendingComparator["default"])[0];
      return this.transforms.get(firstKey);
    }
    /**
     * Returns the rectangle for this layer at the specified frame
     *
     * @param {number} frameNumber
     * @return {object}
     */

  }, {
    key: "getLayerRectangleAtFrame",
    value: function getLayerRectangleAtFrame(frameNumber) {
      var transform = this.getAbsoluteTransformsAtFrame(frameNumber);
      if ((0, _isNil["default"])(transform)) return null;
      var rotation = transform.rotation,
          scale = transform.scale,
          translation = transform.translation;
      return new _Rectangle["default"](translation.x, translation.y, this.width * scale.x, this.height * scale.y, rotation);
    }
    /**
     * Utility Helper to get media URL
     *
     * @param creativeLayer
     * @returns {String} mediaUrl
     */

  }, {
    key: "internalGenerateContentStoreId",

    /**
     * Generates a key used by ContentStore for storing layer frame data.
     * @returns {String}
     */
    value: function internalGenerateContentStoreId() {
      return this._contentId;
    }
    /**
     * Utility Helper to determine if this layer is visible and active at any point during a given input frame range
     *
     * @param creativeLayer: CreativeLayer
     * @param inputFrameRange: FrameRange
     * @returns {boolean}
     */

  }, {
    key: "isActiveInFrame",

    /**
     * Utility Helper to determine if a creative layer is active in a given frame number
     *
     * @param frameNumber
     * @returns {boolean}
     */
    value: function isActiveInFrame(frameNumber) {
      var _this$activeRange = this.activeRange,
          frameStart = _this$activeRange.start,
          frameEnd = _this$activeRange.end; // If current frame is outside bounds of this element, return false

      return frameStart <= frameNumber && frameEnd >= frameNumber;
    }
    /**
     * Utility Helper to determine if this layer active at any point during a given input frame range
     *
     * @param inputFrameRange: FrameRange
     * @returns {boolean}
     */

  }, {
    key: "isActiveInFrameRange",
    value: function isActiveInFrameRange(inputFrameRange) {
      return _FrameRange["default"].isFrameRange(this.activeRange) && this.activeRange.intersects(inputFrameRange);
    }
    /**
     * Checks if layer has a group role equal to display
     *
     * @param layer
     * @returns {boolean}
     */

  }, {
    key: "isDisplayRole",
    value: function isDisplayRole() {
      return this.element.groupRole === _group.GROUP_ROLES.DISPLAY;
    }
    /**
     * Utility Helper to determine if a creative layer is visible in a given frame number
     *
     * @param frameNumber
     * @returns {boolean}
     */

  }, {
    key: "isVisibleForFrame",
    value: function isVisibleForFrame(frameNumber) {
      // immediately return false if layer is not loaded or is not visible
      if (!CreativeLayer.isVisibleCreativeLayer(this)) return false;
      if (!this.loaded) return false;
      if (!this.visible) return false;
      return this.isActiveInFrame(frameNumber);
    }
    /**
     * Checks if object is an instance of CreativeLayer
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "activeRange",
    get: function get() {
      return this._activeRange;
    }
  }, {
    key: "alphaCompositeRule",
    get: function get() {
      return this._alphaCompositeRule;
    },
    set: function set(value) {
      this._alphaCompositeRule = value;
    }
  }, {
    key: "audible",
    get: function get() {
      return this._audible;
    },
    set: function set(value) {
      this._audible = value;
    }
  }, {
    key: "content",
    get: function get() {
      return this._content;
    }
  }, {
    key: "contentId",
    get: function get() {
      return this._contentId;
    }
  }, {
    key: "contentStoreId",
    get: function get() {
      return this._contentStoreId;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this._contentType;
    }
  }, {
    key: "creativeFrameRate",
    get: function get() {
      return this._creativeFrameRate;
    },
    set: function set(value) {
      this._creativeFrameRate = value;
    }
  }, {
    key: "creativeNumberOfFrames",
    get: function get() {
      return this._creativeNumberOfFrames;
    },
    set: function set(value) {
      this._creativeNumberOfFrames = value;
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "elementId",
    get: function get() {
      return this._elementId;
    }
  }, {
    key: "frameEnd",
    get: function get() {
      return this._frameRange.end;
    }
  }, {
    key: "frameRange",
    get: function get() {
      return this._frameRange;
    }
  }, {
    key: "frameStart",
    get: function get() {
      return this._frameRange.start;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(height) {
      this._height = height;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "loaded",
    get: function get() {
      return this.media.loaded;
    }
  }, {
    key: "media",
    get: function get() {
      return this._media;
    }
  }, {
    key: "mediaId",
    get: function get() {
      return this._mediaId;
    }
  }, {
    key: "mediaURL",
    get: function get() {
      return this._mediaURL;
    }
  }, {
    key: "meta",
    get: function get() {
      return this._element.meta;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    },
    set: function set(value) {
      if (!CreativeLayer.isCreativeLayer(value)) {
        throw new Error('Must be of type Creative Layer');
      }

      this._parent = value; // update active range

      var _this$frameRange = this.frameRange,
          start = _this$frameRange.start,
          end = _this$frameRange.end;
      var parentFrameRange = value.frameRange;
      var parentFrameStart = parentFrameRange.start,
          parentFrameEnd = parentFrameRange.end;
      var finalFrameStart = Math.max(start, parentFrameStart);
      var finalFrameEnd = Math.min(end, parentFrameEnd); // if parent and child ranges do not overlap, set it to invalid range

      if (finalFrameStart > finalFrameEnd) {
        this._activeRange = new _FrameRange["default"](-1, -1);
      } else {
        this._activeRange = new _FrameRange["default"](finalFrameStart, finalFrameEnd);
      }
    }
  }, {
    key: "transforms",
    get: function get() {
      return this._element.transforms;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(value) {
      this._visible = Boolean(value);
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(width) {
      this._width = width;
    }
  }], [{
    key: "getMediaURL",
    value: function getMediaURL(creativeLayer) {
      if (!CreativeLayer.isCreativeLayer(creativeLayer)) return null;
      var media = creativeLayer.media;
      if ((0, _isEmpty["default"])(media)) return null;
      var mediaURL = (0, _getMediaUrlByMedia["default"])(media);
      if ((0, _isEmptyString["default"])(mediaURL)) return null;
      var templateId = media.templateId;

      if ((0, _isNotNil["default"])(templateId)) {
        return (0, _appendQueryParams["default"])(mediaURL, {
          templateId: templateId
        });
      }

      return mediaURL;
    }
  }, {
    key: "isVisibleAndActiveInFrameRange",
    value: function isVisibleAndActiveInFrameRange(creativeLayer, inputFrameRange) {
      return creativeLayer.visible && creativeLayer.isActiveInFrameRange(inputFrameRange);
    }
  }, {
    key: "isCreativeLayer",
    value: function isCreativeLayer(inputObject) {
      return inputObject instanceof CreativeLayer;
    }
    /**
     * Checks if object is a CreativeLayer that is visible
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isVisibleCreativeLayer",
    value: function isVisibleCreativeLayer(inputObject) {
      return CreativeLayer.isCreativeLayer(inputObject) && !_creative.INVISIBLE_CONTENT_TYPES.has(inputObject.contentType);
    }
  }, {
    key: "getRootParent",
    value: function getRootParent(creativeLayer) {
      if (!CreativeLayer.isCreativeLayer(creativeLayer)) {
        throw new Error('Must provide a valid CreativeLayer');
      }

      var parent = creativeLayer.parent;
      if (!CreativeLayer.isCreativeLayer(parent)) return null;
      if (!CreativeLayer.isCreativeLayer(parent.parent)) return parent; // if parent has a parent, keep searching up!

      return CreativeLayer.getRootParent(parent);
    }
  }, {
    key: "getRootActiveRange",
    value: function getRootActiveRange(creativeLayer) {
      if (!CreativeLayer.isCreativeLayer(creativeLayer)) {
        throw new Error('Must provide a valid CreativeLayer');
      }

      var frameRange = creativeLayer.frameRange,
          parent = creativeLayer.parent;
      if (!CreativeLayer.isCreativeLayer(parent)) return frameRange.copy();
      var parentActiveRange = CreativeLayer.getRootActiveRange(parent);
      if (!_FrameRange["default"].isFrameRange(parentActiveRange)) return frameRange.copy();
      return _FrameRange["default"].intersection(frameRange, parentActiveRange);
    }
  }]);
  return CreativeLayer;
}();

exports["default"] = CreativeLayer;